/**
 * USER-GENERAL-INFO.WIDGET
 * Edit firstname, lastname, email pro and email perso for a user
 */

import { WithTranslation, withTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import TextInput from "@/components/text-input"
import { checkEmail } from "@/utils/validate-email.utils"
import { STATUS_LOADING, STATUS_SAVED, STATUS_SAVE_ERROR, STATUS_SAVING } from "@/redux/_status.types"
import { store } from "@/index"
import { userStatus } from "@/redux/user.actions"

interface OwnProps {
  firstname?: string
  lastname?: string
  email?: string
  onEdit: Function
  userId: string
  emailCanBeNull?: boolean // if true do not check email and do not set error if email is empty
}

type Props = OwnProps & WithTranslation

function UserGeneralInfoWidget(props: Props) {
  const { t } = props

  // Status for email pro only
  const [emailStatus, setEmailStatus] = useState(STATUS_LOADING)
  const [emailError, setEmailError] = useState<string | null>(null)

  const [firstname, setFirstname] = useState<string>(props.firstname ?? "")
  const [lastname, setLastname] = useState<string>(props.lastname ?? "")
  const [email, setEmail] = useState<string>(props.email ?? "")

  useEffect(() => {
    setFirstname(props.firstname ?? "")
  }, [props.firstname])

  useEffect(() => {
    setLastname(props.lastname ?? "")
  }, [props.lastname])

  useEffect(() => {
    setEmail(props.email ?? "")
  }, [props.email])

  // Check if email is valid (pro email only)
  async function validateEmail() {
    setEmailStatus(STATUS_SAVING)
    if (props.emailCanBeNull && email === "") {
      props.onEdit("email", null)
      setEmailError(null)
      setEmailStatus(STATUS_SAVED)
      store.dispatch(userStatus(STATUS_SAVED))
    } else {
      const response: string = await checkEmail(email, props.userId)
      if (response === "OK") {
        props.onEdit("email", email)
        setEmailError(null)
        setEmailStatus(STATUS_SAVED)
        store.dispatch(userStatus(STATUS_SAVED))
      } else {
        setEmailError(response)
        setEmailStatus(STATUS_SAVE_ERROR)
        store.dispatch(userStatus(STATUS_SAVE_ERROR))
      }
    }
  }

  return (
    <div>
      <div className="flex">
        <TextInput
          onChange={(e) => setFirstname(e.value)}
          isFullWidth
          onBlur={() => props.onEdit("firstname", firstname)}
          title={t("user_firstname")}
          value={firstname}
        />

        <div className="width-20" />

        <TextInput
          onChange={(e) => setLastname(e.value)}
          isFullWidth
          onBlur={() => props.onEdit("lastname", lastname)}
          title={t("user_lastname")}
          value={lastname}
        />
      </div>

      <div className="flex" style={{ marginTop: 10, gap: 20 }}>
        <TextInput
          status={emailStatus}
          onBlur={validateEmail}
          onChange={(e: any) => setEmail(e.value)}
          error={!!emailError}
          title={t("user_email")}
          value={email}
          isFullWidth
        />
        {emailError && (
          <div className="red-t" style={{ marginTop: 42 }}>
            <b>{t(emailError)}</b>
          </div>
        )}
      </div>
    </div>
  )
}

export default withTranslation()(UserGeneralInfoWidget)
